/* Core & libraries */
import React, { useEffect } from 'react'
import { FormattedMessage } from "react-intl";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCButton from "../../../../buttons";

/* Styles */
import { colors } from "../../../../../constants/colors";


const CustomSubmitButton = (props) => {
  const { className,
    buttonClassName,
    style,
    buttonStyle,
    disabled,
    content,
    onSubmit,
    files,
    correctNumberOfCommas,
    nameColumnPresent,
    maskedColumnPresent,
    advancedNumberColumnPresent,
    tierColumnPresent,
    maxTravelersNumber,
    emptyRows} = props

  const _disabled =
    files.some(f => ['preparing', 'getting_upload_params', 'uploading'].includes(f.meta.status)) ||
    !files.some(f => ['ready'].includes(f.meta.status)) ||
    !correctNumberOfCommas ||
    !nameColumnPresent ||
    !maskedColumnPresent ||
    !advancedNumberColumnPresent ||
    !tierColumnPresent ||
    emptyRows ||
    maxTravelersNumber

  const handleSubmit = () => {
    onSubmit(files.filter(f => ['headers_received', 'done'].includes(f.meta.status)))
  }

  return (
    <UCButton
      spinner={{
        name: "uploadFileSpinner",
        size: 20,
        color: colors.white
      }}
      className={buttonClassName}
      style={buttonStyle}
      type="primary"
      text={<FormattedMessage id="loyalty.atmBulkImport.bulkImport" />}
      onClick={handleSubmit}
      disabled={disabled || _disabled}
    />
  )
}

export default CustomSubmitButton